import request from "@/utils/request";
import { permission as JsonPermission } from "@/config/permission.json";
import { pidToPNode } from "@/utils";

// 微信登录
export function wxLogin(data) {
  let url = "/wx/sys/login";
  if (data.code) {
    url = url + "?code=" + data.code;
  }
  return request.post(url, data).then((response) => {
    const { data, ...res } = response;
    if (data.message === "success" || data.code === 2000) {
      data.message = "登录成功";
    }
    return { ...res, data };
  });
}

// 用户登录
export function login(data) {
  return request.post("/sys/login", data).then((response) => {
    const { data, ...res } = response;
    if (data.message === "success" || data.code === 2000) {
      data.message = "登录成功";
    }
    return { ...res, data };
  });
}

// 退出登录
export function logout() {
  return request.post("/sys/logout");
}

// 获取用户信息
export function getSelf() {
  const adminPermission = [];
  JsonPermission?.list?.forEach((permission) => {
    const { detail } = permission;
    adminPermission.push(...detail);
  });

  return request.post("/sys/user/info").then(({ data }) => {
    const { menuIds, user, ...otherData } = data;
    const newData = {
      address: user.address || "",
      avatar: user.avatar || "",
      birthday: user.birthday || "",
      department: user.department || "",
      downStatus: user.downStatus || 0,
      email: user.email || "",
      faceImgUrl: user.faceImgUrl || "",
      hiredate: user.hiredate || "",
      id: user.id,
      name: user.name,
      // permission: user.username === 'admin' ? adminPermission : pidToPNode(menuIds),
      permission: pidToPNode(menuIds),
      personOrderId: user.personOrderId,
      personType: user.personType,
      phone: user.mobile,
      position: user.position || "",
      remark: user.description || "",
      role: user.roleIdList || [],
      sex: user.sex || "",
      username: user.username,
      wxoa: user.wxoa || "",
      wxwork: user.wxwork || "",
    };
    return { data: { ...otherData, data: newData } };
  });
}

// 更新用户信息
export function updatePassword(data) {
  return request.post("/sys/user/password", data);
}
